<app-autocomplete-select
  placeholder="{{'search.group' | translate}}"
  [options]="options"
  [(ngModel)]="value"
  style="width: 100%">
</app-autocomplete-select>
